<template>
	<OrganismMainMenuMobile
		class="lg:hidden"
		:is-open="isMobileMenuOpen"
		:menu-items="mainMenuItems('mobile')"
		:service-menu-items="menuServiceItems"
		@close="closeMobileMenu"
		@click-appointment-button="openAppointmentDialog"
	/>
	<OrganismDialogCookieConsent />
</template>

<script lang="ts" setup>
import menuServiceItems from '#fit/core/consts/menuServiceItems';

const {
	openAppointmentDialog,
	isMobileMenuOpen,
	closeMobileMenu,
} = useDialogs();
</script>
